module.exports = __webpack_public_path__ + "static/media/a.1e4b65cb.jpg";